import { useTranslation } from 'react-i18next';
import ExoForm from '../exo/ExoForm';
import FolderIcon from '@mui/icons-material/Folder';
import { API_PATCH, API_POST, DBRequest, useConfig } from '../../api/api';
import * as Yup from 'yup';
import { useEffect, useState } from 'react';
import moment from 'moment';

export const NewInteractionNote = ({
  onUpdate,
  onCreate,
  startData,
  onClose,
  onDelete,
  type = '',
  source = null,
  sourceType = null,
  onFeedback,
}) => {
  const { t } = useTranslation();
  const config = useConfig();

  const [startDataCollection, setStartDataCollection] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const dateMoment = moment(startData?.dateTime);
    const date = dateMoment.format('YYYY-MM-DD');
    const time = dateMoment.toISOString();

    if (startData && startData.id) {
      showRequest(startData.id);
    } else {
      setStartDataCollection({ ...startData, date, time });
    }
  }, [startData, config]);

  function showRequest(id) {
    DBRequest({
      config,
      path: `interactions/${id}`,
      onLoading: setIsLoading,

      onResponse: (res) => {
        const dateMoment = moment(res.data.dateTime);
        const date = dateMoment.format('YYYY-MM-DD');
        const time = dateMoment.format();

        setStartDataCollection({ ...res.data, date, time });
      },
    });
  }

  const fields = [
    {
      label: t('Title'),
      key: 'title',
      type: 'text',
      colspan: 2,
    },
    {
      Icon: FolderIcon,
      label: t('Files'),
      key: 'files',
      type: 'images',
      size: 'small',
      maxItems: 5,
      maxSizeKB: 5000,
    },
    {
      label: t('Note'),
      key: 'note',
      type: 'richTextEditor',
      colspan: 2,
    },
    {
      label: t('Participants'),
      key: 'participants',
      type: 'participantsAutoComplete',
      colspan: 2,
      searchParams: [
        'companies',
        'contacts',
        'person_leads',
        'company_leads',
        'users',
      ],
      size: 'small',
    },
  ];

  function handleSubmit(data) {
    const isUpdate = Boolean(data.id);
    const time = moment(data.time).format('HH:mm');
    const dateTime = moment(
      `${data.date} ${time}`,
      'YYYY-MM-DD HH:mm'
    ).toISOString();

    const reqData = { ...data, dateTime, source, sourceType };

    DBRequest({
      config,
      path: isUpdate ? `interactions/${data.id}` : `interactions`,
      method: isUpdate ? API_PATCH(reqData) : API_POST(reqData),
      onLoading: setIsLoading,
      onFeedback,
      onResponse: (res) => {
        onClose();
        return isUpdate ? onUpdate(res) : onCreate(res);
      },
    });
  }

  const validationSchema = Yup.object().shape({
    date: Yup.string().required(t('Is required')),
    time: Yup.string().required(t('Is required')),
    title: Yup.string().required(t('Is required')),
    type: Yup.string().required(t('Is required')),
    participants: Yup.array()
      .of(
        Yup.object().shape({
          email: Yup.string(),
          type: Yup.string(),
          participant: Yup.object().shape({
            id: Yup.string(),
          }),
        })
      )
      .min(1)
      .required(t('Is required')),
    address: Yup.object()
      .shape({
        street: Yup.string(),
        houseNumber: Yup.string(),
        zipCode: Yup.string(),
        city: Yup.string(),
        countryCode: Yup.string(),
      })
      .nullable(),
  });

  return (
    <ExoForm
      noDifferences
      isLoading={isLoading}
      startDataCollection={startDataCollection}
      fields={fields}
      header={t('New note')}
      onSubmit={handleSubmit}
      className="grid grid-cols-2 gap-4 max-h-full overflow-y-auto pt-2"
      validationSchema={validationSchema}
      onCancle={onClose}
    />
  );
};
